"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var apollo_link_1 = require("apollo-link");

var assocWhenNotEmpty = function assocWhenNotEmpty(key, value) {
  return R.when(R.always(R.complement(R.either(R.isNil, R.isEmpty))(value)), R.assoc(key, value));
};

var AuthHeadersLink =
/*#__PURE__*/
function (_apollo_link_1$Apollo) {
  _inherits(AuthHeadersLink, _apollo_link_1$Apollo);

  function AuthHeadersLink(_ref) {
    var _this;

    var getAuthState = _ref.getAuthState;

    _classCallCheck(this, AuthHeadersLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthHeadersLink).call(this));
    _this.getAuthState = getAuthState;
    return _this;
  }

  _createClass(AuthHeadersLink, [{
    key: "request",
    value: function request(operation, forward) {
      var _this2 = this;

      return new apollo_link_1.Observable(function (observer) {
        var _this2$getAuthState = _this2.getAuthState({
          operation: operation
        }),
            token = _this2$getAuthState.token,
            workspaceId = _this2$getAuthState.workspaceId;

        operation.setContext(R.over(R.lensProp('headers'), R.pipe(assocWhenNotEmpty('authorization', token ? "Bearer ".concat(token) : null), assocWhenNotEmpty('workspace', workspaceId))));
        forward(operation).subscribe({
          complete: function complete() {
            return observer.complete.apply(observer, arguments);
          },
          error: function error() {
            return observer.error.apply(observer, arguments);
          },
          next: function next() {
            return observer.next.apply(observer, arguments);
          }
        });
      });
    }
  }]);

  return AuthHeadersLink;
}(apollo_link_1.ApolloLink);

exports.AuthHeadersLink = AuthHeadersLink;